import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';

class CargoCredito extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'cargo-credito/one', saveUrl: 'cargo-credito/save', backUrl: '/Catalogo/Cargos' },
      new Form([
        Form.Field('text', 'cargo_credito', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'cc_nombre', 'Descripcion', '', [Validators.required], 4),
        Form.Field('select', 'id_cc_tipos', 'Tipo', '', [Validators.required], 4),
      ], ['Guardar'], 'Cargo/Credito'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  formData = async (form) => {
    const Res = await Http.get('cargo-credito-tipo/all');

    if (!Res.error) {
      
      const cargosTipos = Form.FieldOptions(form, 'id_cc_tipos', Res.data, 'id', 'cc_tipo');
      return cargosTipos;
    }
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(CargoCredito)
